import styled from 'styled-components';

export const PerfilContainer = styled.div``;

export const Title = styled.p`
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #454f63;
  opacity: 1;
  margin: 50px 0 30px 0;
`;

export const ContentBox = styled.div`
  width: 757px;
  height: 153px;
  background: #fbfbfc 0% 0% no-repeat padding-box;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  opacity: 1;
  padding: 16px;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
`;

export const SubTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SubTitle = styled.p`
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #454f63;
  opacity: 1;
  padding-left: 10px;
`;

export const Field = styled.span`
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #78849e;
  margin-bottom: 10px;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;

  :first-child {
    min-width: 450px;
  }
`;

export const FieldBox = styled.div`
  display: flex;
  margin-top: 16px;
`;

export const ButtonIcon = styled.button`
  border: none;
  background-color: #fff;
`;
